import React from 'react';
import PropTypes from 'prop-types';

const HelyszinItem = (props) => {
  return (
    <div className={"col-md-3"}>
      <div className={"card" + (props.active ? ' card-active' : '')} onClick={() => props.onClick(props.item)} style={{ padding: 25, cursor: 'pointer', marginTop: 20, marginBottom: 20 }}>
        <div className="card-body">
          {props.title}
        </div>
      </div>
    </div>
  );
};

HelyszinItem.defaultProps = {
  item: null,
  active: false,
  title: '-',
  onClick: () => {}
};

HelyszinItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.bool,
  title: PropTypes.string,
  onClick: PropTypes.func
};

export default HelyszinItem;
